import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewRoute.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class NewRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      route_id  : '',
      customers : [],
      customer : {},
      day : {},
      days : [],
      customer_type : 'D',
      schedules : [],
      route_name:'',
      existing_route_ids  : [],
      final_route_ids  : []
    }
    this.formChange = this.formChange.bind(this);
    this.remarksReq = React.createRef();

  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    const { pathname } = this.props.location;
    if (pathname === "/routes/new") {
      this.getRouteCustomers();    
    }
    else{
      this.editRouteCustomers();
    }
  }

  // customerTypeChange(e) {
  //   this.getRouteCustomers(e.target.value);
  //   this.setState({
  //     customer_type: e.target.value
  //   });
  // }

  getRouteCustomers(){
    const customer_type = "D";
    const url = `${process.env.REACT_APP_SSS}/api/getRouteCustomers`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        // customer_type : customer_type
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          customers : return_data.customers,
          days : return_data.days,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }
  editRouteCustomers(){
    const route_id = this.props.match.params.route_id;
    const url = `${process.env.REACT_APP_SSS}/api/editRoutes`;
    this.context.loading(1);
    var obj_this = this;
    obj_this.setState({
      route_id  : route_id
    });
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        route_id : route_id
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        var schedules = return_data.schedules;
        schedules = schedules.filter((item) => item.customer);
        var existing_route_ids = schedules.map((item)=>item.id);

        obj_this.setState({
          schedules : schedules,
          customers : return_data.customers,
          route_name: return_data.routes.route_name,
          existing_route_ids : existing_route_ids,
          days : return_data.days,
          day : return_data.day
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network ERror");
    });
  }
  

  customerChange(option){
    // console.log(option);
    this.setState({
      customer : option
    }); 
  }

  dayChange(option){
    // console.log(option);
    this.setState({
      day : option
    }); 
  }


  onDateChange(value){
    // console.log(value);
    this.setState({scheduled_date : value});
  }

  handleAddSchedule = () => {
    // console.log(this.state.rows);
    if(!this.state.customer.label){
      // alert('Date required');
      return;
    }
    const schedule = {
      customer : this.state.customer,
      customer_type : this.state.customer_type,
    };

    const schedules = this.state.schedules;

    for(var i=0;i<schedules.length;i++){
      if(schedules[i].customer.label === schedule.customer.label){
        alert(schedule.customer.label+" is already added to route");
        return;
      }
    }
    this.setState({
      schedules: [...this.state.schedules, schedule],
      customer : {},
    });    
  };

  handleRemoveSchedule = (idx) => () => {
    // console.log(idx);
    const schedules = [...this.state.schedules];
    schedules.splice(idx, 1);
    this.setState({ 
      schedules 
    });

  }

  formSubmit(e){
    e.preventDefault();
    // if(!this.state.schedules.length){
    //   return;
    // } //Removed manadatory customer
    if(!this.state.day.label){
      this.remarksReq.current.focus();
      return;
    }
    const schedules = this.state.schedules.map((plannedLocation) => ({
      customer: {
        value: plannedLocation.customer.value,
      },
    }));
    const final_route_ids  = this.state.schedules.map(item=>item.id);
    const url = `${process.env.REACT_APP_SSS}/api/saveNewRoutes`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        route_id  : this.state.route_id,
        route_name  : this.state.route_name,
        planned_locations : schedules,
        existing_route_ids : this.state.existing_route_ids,
        final_route_ids : final_route_ids,
        day : this.state.day
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({ 
          schedules : []
        });
        alert("Route added");
        obj_this.props.history.replace('/routes');
        obj_this.context.loading(0);
      }else if(return_data.status=="duplicate route name"){
        alert("Route exist with same name");
        obj_this.context.loading(0);
      }
      else if(return_data.status == "already"){
        // obj_this.setState({ 
        //   schedules : []
        // });
        alert("Customer "+(return_data.customer_name)+" already added in another route");
        obj_this.context.loading(0);
      }
      else if (return_data.status ==  "update"){
          alert("Route updated successfully");
          obj_this.props.history.replace("/routes");
          obj_this.context.loading(0);
      }
      else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
  }
  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_schedule_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.route_id?'Edit':'New'} Route</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="customer_details_container blocks">
              {/* <div className="customer_type_radio_buttons">
                <div className="label_radio_container">
                  <input type="radio" 
                    name="customer_type" 
                    value="D"  
                    checked={this.state.customer_type === 'D'}
                    onChange={e => this.customerTypeChange(e)}
                  />
                  <div>Dealer</div>
                </div>
               
              </div> */}
               <div className="input_label">Route Name</div>
               <textarea className="input activity custom_input" 
                name="route_name"
                value={this.state.route_name}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              <div className="input_label">Assign to Day</div>
              <Select 
                options={this.state.days}  
                value ={this.state.day}
                className="customer_day" 
                onChange={e => this.dayChange(e)}
                required
                ref={this.remarksReq}
                styles={{
                  menuList: styles => {
                  // console.log('menuList:', styles);
                  return {
                    ...styles,
                    maxHeight: 222
                  };
                }}}
              />

              <div className="input_label">Customer</div>
              <Select 
                options={this.state.customers}  
                value ={this.state.customer}
                className="customer_day" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.customerChange(e)}
                required
                styles={{
                  menuList: styles => {
                  // console.log('menuList:', styles);
                  return {
                    ...styles,
                    maxHeight: 222
                  };
                }}}
              />
            
              <div className="add_button_container">
                <button className="add_schedule_button"
                  type="button"
                  style={{visibility:this.state.customer.label?"visible":"hidden"}}
                  onClick={this.handleAddSchedule}
                > 
                  <i className="fa fa-plus"></i> Add
                </button>
              </div>
            </div>
            <div className="schedules_table_container blocks"
              style={{visibility:this.state.schedules.length?"visible":"hidden"}}
            >
              <table>
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th align="left">Customer</th>
                    <th align="left">Location</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.schedules.map((item,idx) => (
                    <tr key={idx}>
                      <td align="center">{idx+1}</td>
                      <td>{item.customer.label}</td>
                      <td>{item.customer.location_name??"Not Mapped"}</td>
                      <td align="center">
                        <i className="remove_schedule_button fas fa-times"
                          onClick={this.handleRemoveSchedule(idx)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button type="submit" 
            className="submit_button"
            // style={{visibility:this.state.schedules.length?"visible":"hidden"}}
            >
              <i className="far fa-save"></i> Save
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewRoute;
NewRoute.contextType = MyContext;
